import { DatePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import ModalComentarioAuditoria from "components/modal/auditoria/ModalComentarioAuditoria";
import dayjs from "dayjs";
import Usuario from "model/administracao/cadastro/Usuario";
import Auditoria from "model/auditoria5s/auditoria/Auditoria";
import ClasseAuditoria from "model/auditoria5s/auditoria/ClasseAuditoria";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useState } from "react";
import AuditoriaService from "service/auditoria5s/AuditoriaService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterDataHora } from "utils/convert";

const auditoriaService = new AuditoriaService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function AuditoriaCadastro() {

    const titulo = "Auditoria";
    const [auditoria, setAuditoria] = useState<Auditoria>(new Auditoria());
    const [classeSelecionada, setClasseSelecionada] = useState<ClasseAuditoria | null>(null);
    const [itemSelecionado, setItemSelecionado] = useState<ItemClasseAuditoria | null>(null);

    const [visibleCancelarAuditoria, setVisibleCancelarAuditoria] = useState(false);
    const [podeCancelarAuditoria, setPodeCancelarAuditoria] = useState(false);

    const [usuariosDisponiveis, setUsuariosDisponiveis] = useState<Usuario[]>([]);

    const [visibleModalImage, setVisibleModalImage] = useState(false);

    const { msgAlerta } = useToastContext();

    useEffect(() => {
        auditoriaService.getUsuariosDisponiveis().then(json => {
            setUsuariosDisponiveis(json);
        }).catch(e => {
            console.error(e);
        });

        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAcao(resposta, "AUDITORIA_CANCELAR")) {
                setPodeCancelarAuditoria(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });

    }, [])

    function validar() {

        if (!auditoria.usuario) {
            return false;
        }
        if (!auditoria.status) {
            return false;
        }

        return true;
    }

    function converteData(data: Date | null): string {
        if (data == null) {
            return "";
        }
        data = new Date(data);
        return data.getDate().toString().padStart(2, "0") + "/" + (data.getMonth() + 1).toString().padStart(2, "0") + "/" + data.getFullYear().toString() + " " + data.getHours().toString().padStart(2, "0") + ":" + data.getMinutes().toString().padStart(2, "0");
    }


    const botoesExtra = () => {
        return (
            <>
                {podeCancelarAuditoria && auditoria.status !== "CANCELADA" && auditoria.status !== "FINALIZADA" && <Button label="Cancelar auditoria" onClick={() => setVisibleCancelarAuditoria(true)} style={{ marginLeft: 8 }} />}
            </>
        )
    }

    function cancelarAuditoria() {
        if (auditoria.observacaoCancelamento == null || auditoria.observacaoCancelamento.trim() == "") {
            msgAlerta("Atenção", "Informe a observação para cancelamento da auditoria");
            return;
        }
        auditoriaService.cancelarAuditoria(auditoria).then(() => {
            setAuditoria({ ...auditoria, status: "CANCELADA" });
            setVisibleCancelarAuditoria(false);
        }).catch(e => {
            console.error(e);
        })
    }

    return (

        <BaseCadastro model={auditoria} botoesExtra={botoesExtra()} service={auditoriaService} setModel={(value: Auditoria) => setAuditoria(value)} validar={() => validar()} urlService="/Auditoria" pathCadastro="/Auditoria" tituloPagina={''}>
            {visibleModalImage ? <ModalComentarioAuditoria visible={visibleModalImage} setVisible={(e) => setVisibleModalImage(e)} item={itemSelecionado} /> : null}

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            {visibleCancelarAuditoria ? <Dialog header="Cancelar auditoria"
                footer={<>
                    <Button label="Fechar" onClick={() => setVisibleCancelarAuditoria(false)} />
                    <Button label="Confirmar" onClick={() => cancelarAuditoria()} />
                </>}
                visible={visibleCancelarAuditoria} style={{ width: '50vw' }} onHide={() => setVisibleCancelarAuditoria(false)} contentStyle={{ display: "flex", flexDirection: "column" }}>
                <Label label="Observação" obrigatorio />
                <InputTextarea value={auditoria.observacaoCancelamento} onChange={(e) => setAuditoria({ ...auditoria, observacaoCancelamento: e.target.value })} style={{ width: '100%' }} />
            </Dialog> : null}
            <div style={{ display: "flex" }}>
                <Checkbox
                    disabled
                    checked={auditoria.finalizadaAutomaticamente}
                    style={{ marginRight: 5 }} />
                <label>Finalizada Automaticamente</label>
            </div>
            <div className="row">
                <Label className="col col-sm-12">Nome</Label>
                <div className="col-sm-12">
                    <InputText value={auditoria.nome} readOnly onChange={(e) => setAuditoria({ ...auditoria, nome: e.target.value })} style={{ width: '100%' }} />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12">Setor</Label>
                <div className="col-sm-12">
                    <InputText value={auditoria.setor?.nome} readOnly style={{ width: '100%' }} />
                </div>

            </div>
            <div className="row">
                <Label className="col col-sm-12">Unidade Organizacional</Label>
                <div className="col-sm-12">
                    <InputText value={auditoria.unidadeOrganizacional?.nome || ""} readOnly style={{ width: '100%' }} />
                </div>

            </div>
            <div className="row">
                <Label className="col col-sm-12">Mês</Label>
                <div className="col-sm-12">
                    <InputText value={auditoria.mes?.toString()} readOnly style={{ width: '10%', marginRight: 10 }} />
                    <InputText value={auditoria.ano?.toString()} readOnly style={{ width: '20%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Data Geração</Label>
                <div className="col-sm-12">
                    <InputText value={converterDataHora(auditoria.dataGeracao)} readOnly style={{ width: '15%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Data Início</Label>
                <div className="col-sm-12">
                    <InputText value={converteData(auditoria.dataInicio)} readOnly style={{ width: '15%' }} />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12">Data Fim</Label>
                <div className="col-sm-12">
                    <InputText value={converteData(auditoria.dataFim)} readOnly style={{ width: '15%' }} />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12">Data Limite</Label>
                <div className="col-sm-12">
                    <DatePicker
                        value={dayjs(auditoria.dataLimite)}
                        onChange={value => {
                            setAuditoria({ ...auditoria, dataLimite: value?.startOf("day").toDate() || null })
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12">Responsavel</Label>
                <div className="col-sm-12">
                    <Dropdown
                        onChange={(e) => setAuditoria({ ...auditoria, usuario: e.target.value })}
                        value={auditoria.usuario}
                        optionLabel="nome"
                        options={usuariosDisponiveis}
                        filter
                        style={{ width: '15%' }}
                    />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12">Status</Label>
                <div className="col-sm-12">
                    <Dropdown
                        onChange={(e) => setAuditoria({ ...auditoria, status: e.target.value })}
                        value={auditoria.status}
                        optionValue="value"
                        optionLabel="label"
                        optionDisabled={(option) => {
                            return true;
                        }}
                        options={[
                            { value: "CRIADA", label: "Criada" },
                            { value: "EM_ANDAMENTO", label: "Em andamento" },
                            { value: "FINALIZADA", label: "Finalizada" },
                            { value: "CANCELADA", label: "Cancelada" }
                        ]}
                        style={{ width: '15%' }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Observação</Label>
                <div className="col-sm-12">
                    <InputTextarea value={auditoria.observacao} style={{ width: "50%" }} readOnly />
                </div>
            </div>

            {auditoria.status === "CANCELADA" ? <div className="row">
                <Label className="col col-sm-12">Observação de cancelamento</Label>
                <div className="col-sm-12">
                    <InputTextarea value={auditoria.observacaoCancelamento} style={{ width: "50%" }} readOnly />
                </div>
            </div> : null}
            <div className="row">
                <Label className="col col-sm-12">Nota final</Label>
                <div className="col-sm-12">
                    <InputText value={auditoria.notaFinal != null ? auditoria.notaFinal.toString() : ""} readOnly style={{ width: '15%' }} />
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <DataTable
                        header="Classes"
                        emptyMessage="Nenhuma classe encontrada"
                        value={auditoria.classesAuditoria}
                        selectionMode="single"
                        selection={classeSelecionada!}
                        onSelectionChange={(e) => {
                            setItemSelecionado(null);
                            setClasseSelecionada(e.value as ClasseAuditoria)
                        }}
                    >
                        <Column field="nome" header="Nome" />
                        <Column field="notaMaxima" header="Nota máxima" />
                        <Column field="notaFinal" header="Nota" />

                    </DataTable>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <DataTable
                        header="Itens"
                        emptyMessage="Nenhum item encontrado"
                        selectionMode="single"
                        selection={itemSelecionado!}
                        onSelectionChange={(e) => setItemSelecionado(e.value as ItemClasseAuditoria)}
                        value={classeSelecionada?.itensAuditoria ? classeSelecionada.itensAuditoria : []}
                        scrollable={true}
                        scrollHeight="400px"
                        onRowDoubleClick={(e) => { setVisibleModalImage(true) }}
                    >
                        <Column field="requisitoAuditoria.classificacaoRequisito.nome" header="Classificação" />
                        <Column field="nome" header="Nome" />
                        <Column field="descricao" header="Descrição" />
                        <Column field="resposta" header="Resposta" body={(rowData) => rowData.respostaEscolhida ? rowData.respostaEscolhida : rowData.resposta} />
                        <Column field="resultado" body={(rowData) => auditoriaService.getResultadoItemAuditoria(rowData.resultado)} header="Resultado" />
                        <Column field="status" body={(rowData) => auditoriaService.getStatusItemAuditoria(rowData.status)} header="Status" />
                        <Column style={{ textAlign: "center" }} header={<i className="pi pi-comment" ></i>} body={(rowData: ItemClasseAuditoria) => {
                            return rowData.comentariosAuditoria && rowData.comentariosAuditoria.length > 0 ?
                                <Button icon="pi pi-comment" className="p-button-rounded" onClick={(e) => {
                                    setItemSelecionado(rowData);
                                    setVisibleModalImage(true);
                                }} /> : null
                        }} />

                    </DataTable>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <DataTable
                        header="Ações"
                        emptyMessage="Nenhuma ação encontrada"
                        value={itemSelecionado?.acoesAuditoria ? itemSelecionado.acoesAuditoria : []}

                    >
                        <Column field="nome" header="Nome" />
                        <Column field="descricao" header="Descrição" />
                        <Column field="resposta" header="Resposta" />
                        <Column field="status" body={(rowData) => auditoriaService.getStatusAcaoAuditoria(rowData.status)} header="Status" />
                        <Column field="responsavel.nome" header="Responsável" />

                    </DataTable>
                </div>
            </div>
        </BaseCadastro>
    )
}